import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

// SAGA FLOW EXAMPLE FOR FUTURE API INTEGRATION

const selectDomain = (state: any) => state.campaignsState || initialState;

// Step-4: Making the state available for the files to be called through
export const campaignsSelector = createSelector(
  selectDomain,
  (state) => state.campaigns
);

export const insightsSelector = createSelector(
  selectDomain,
  (state) => state.insights
);

export const isCampaignsLoadingSelector = createSelector(
  selectDomain,
  (state) => state.isLoading
);
export const campaignsFilterSelector = createSelector(
  selectDomain,
  (state) => state.filter
);

export const insightFilterSelector = createSelector(
  selectDomain,
  (state) => state.insightFilter
);

export const campaignsSkipSelector = createSelector(
  selectDomain,
  (state) => state.skip
);

export const campaignsSearchSelector = createSelector(
  selectDomain,
  (state) => state.search
);

export const adsAccountListSelector = createSelector(
  selectDomain,
  (state) => state.adsAccounts.accounts
);

export const isAdsAccountLoadingSelector = createSelector(
  selectDomain,
  (state) => state.adsAccounts.isLoading
);

export const campaingsAdCopiesSelector = createSelector(
  selectDomain,
  (state) => state.campaingsAdCopies
);
